import type { NavigateFunction } from 'react-router-dom';

import type { AddFlowLocationState } from '@/types/add-flow-navigation';

function isSafeAppPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.includes('://');
}

/**
 * Cancel from Add Member / Add Pet: prefer browser back, then explicit return path,
 * then Tree View for this family.
 */
export function navigateCancelFromAddFlow(
  navigate: NavigateFunction,
  options: {
    familyId: string;
    locationState: AddFlowLocationState | undefined;
    treeAnchorFallback: string;
  }
): void {
  const { familyId, locationState, treeAnchorFallback } = options;
  const returnTo = locationState?.returnTo;

  if (typeof window !== 'undefined' && window.history.length > 1) {
    navigate(-1);
    return;
  }

  if (returnTo && isSafeAppPath(returnTo)) {
    navigate(returnTo);
    return;
  }

  const anchor = locationState?.originalAnchorId ?? treeAnchorFallback;
  navigate(`/families/${familyId}/hybrid-pedigree/${anchor}`);
}
